import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "Access" }
const _hoisted_2 = { style: {"height":"60px","display":"inline-flex","margin":"0 auto"} }
const _hoisted_3 = { style: {"height":"60px","line-height":"60px","text-align":"center","margin-left":"14px"} }

import { searchFormConfig } from './config/search.config'
import { contentTableConfig } from './config/content.config'
import { usePageSearch } from '@/hooks/userPageSearch'

import { useStore } from '@/store'
import { toDay, secondToString } from '@/utils/date-format'
import { useRoute } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'Access',
  setup(__props) {

const store = useStore()
const userInfo = store.state.login.userInfo

const getEmp = () => {
  const index = searchFormConfig.formItems.findIndex(
    (item) => item.field === 'empIds'
  )
  if (index > -1) {
    searchFormConfig.formItems.splice(index, 1)
  }
  if (userInfo.isManager == '1') {
    const options = store.state.login.depts
    searchFormConfig.formItems.push({
      field: 'empIds',
      type: 'cascader',
      label: '员工',
      placeholder: '请选择员工',
      options: options,
      otherOptions: {
        'show-all-levels': false,
        clearable: true,
        props: {
          multiple: true,
          value: 'id',
          label: 'name',
          children: 'emps',
          emitPath: false
        }
      }
    })
  }
}

getEmp()
const getDept = () => {
  const dept = searchFormConfig.formItems.find(
    (item) => item.field === 'deptId'
  )
  const deptData = store.state.login.depts
  dept!.options = deptData.map((item: any) => {
    return { title: item.name, value: item.id }
  })
}

getDept()
const route = useRoute()
const queryParam = {
  accessTime: [toDay(), toDay()],
  ...route.query
}
store.commit('system/changeQueyryInfo', queryParam)

const resetCb = () => {
  return queryParam
}
const [pageContentRef, handleResetClick, handleSearchClick] =
  usePageSearch(resetCb)

const handleSortChange = (value: any) => {
  console.log(value)
  store.commit('system/changeOrderInfo', {
    orderBy: value.prop,
    orderType: value.order
  })
  const queryInfo = store.state.system.queryInfo
  pageContentRef.value?.getPageData(queryInfo)
}

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_PageContent = _resolveComponent("PageContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "promotionAccess",
      onSortChange: handleSortChange
    }, {
      duration: _withCtx((scope) => [
        _createElementVNode("div", null, _toDisplayString(_unref(secondToString)(scope.row.duration)), 1)
      ]),
      material: _withCtx((scope) => [
        _createVNode(_component_el_link, {
          href: scope.row.url,
          type: "primary",
          target: "_blank"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(scope.row.title), 1)
          ]),
          _: 2
        }, 1032, ["href"])
      ]),
      consumer: _withCtx((scope) => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_avatar, {
            shape: "square",
            size: 60,
            src: scope.row.consumerHeadImgUrl
          }, null, 8, ["src"]),
          _createElementVNode("span", _hoisted_3, _toDisplayString(scope.row.consumerNickName), 1)
        ])
      ]),
      _: 1
    }, 8, ["contentTableConfig"])
  ]))
}
}

})